import { ColumnDef } from '@3ddv/software-division-components/backoffice/table';
import { gsActionsColumn } from '../../shared/ui/table/gs-table.columns';
import { Upgrade } from './models/upgrade.model';

export function buildUpgradeColumns(
  onToggleActive: (upgrade: Upgrade) => void,
  onEdit: (upgrade: Upgrade) => void,
  onDelete: (upgrade: Upgrade) => void,
  canEdit = true
): ColumnDef<Upgrade>[] {
  const nameColumn: ColumnDef<Upgrade> = {
    id: 'name',
    header: 'Name',
    accessorFn: upgrade => upgrade.name,
  };

  const descriptionColumn: ColumnDef<Upgrade> = {
    id: 'description',
    header: 'Description',
    accessorFn: upgrade => upgrade.description,
  };

  const minSeatsColumn: ColumnDef<Upgrade> = {
    id: 'minSeatsToShow',
    header: 'Min. Seats to show',
    accessorFn: upgrade => upgrade.minSeatsToShow,
  };

  const goalColumn: ColumnDef<Upgrade> = {
    id: 'goal',
    header: 'Goal',
    accessorFn: upgrade => upgrade.goal,
  };

  const actionsColumn = gsActionsColumn<Upgrade>({
    actions: [
      {
        id: 'toggle',
        label: upgrade => (upgrade.active ? 'On' : 'Off'),
        tone: upgrade => (upgrade.active ? 'positive' : 'negative'),
        dataCy: upgrade => `upgrade-enable-button-${upgrade.id}`,
      },
      {
        id: 'edit',
        label: 'Edit',
        dataCy: upgrade => `upgrade-edit-button-${upgrade.id}`,
      },
      {
        id: 'delete',
        label: 'Delete',
        destructive: true,
        dataCy: upgrade => `upgrade-delete-button-${upgrade.id}`,
      },
    ],
    onSelect: (actionId, upgrade) => {
      if (actionId === 'toggle') {
        onToggleActive(upgrade);
      } else if (actionId === 'edit') {
        onEdit(upgrade);
      } else if (actionId === 'delete') {
        onDelete(upgrade);
      }
    },
    rowDataCy: upgrade => `upgrade-row-${upgrade.id}`,
  });

  return [
    nameColumn,
    descriptionColumn,
    minSeatsColumn,
    goalColumn,
    ...(canEdit ? [actionsColumn] : []),
  ];
}
